export default __webpack_public_path__ + "assets/37914751a841e5bada7088f083ebe8f1.svg";